import './ChildChooserStrip.css';
import { ChildAvatarHero } from './ChildAvatarHero';
import type { LinkedChild } from '../../lib/queries/parent/useLinkedChildren';

/**
 * Multi-child chooser. Renders a horizontal strip of small avatars
 * when the parent has 2+ linked children. Single child = no chooser
 * needed; render the full ChildAvatarHero in the shell directly.
 */
export function ChildChooserStrip({
  children,
  activeId,
  onSelect,
}: {
  children: LinkedChild[];
  activeId: string | null;
  onSelect: (id: string) => void;
}) {
  if (children.length < 2) return null;
  return (
    <nav className="child-chooser" aria-label="Choose child">
      {children.map((c) => (
        <button
          key={c.id}
          type="button"
          className="child-chooser__item"
          onClick={() => onSelect(c.id)}
          aria-pressed={c.id === activeId}
          title={c.name}
        >
          <ChildAvatarHero child={c} size="sm" active={c.id === activeId} />
          <span className="child-chooser__label">{c.name.split(' ')[0]}</span>
        </button>
      ))}
    </nav>
  );
}
